/*eslint-disable*/
// thisare the configs of console where we add which cutomere allowed to see which featre 
export const notShowNotificationtoCustomer = [52, '52'];
export const notShowToggleButtonstoCusotmer = [52, '52', 70, '70', 67, '67'];
export const operationSummaryDynamicPageAllowedCustomer = ['70', 70, 67, '67', 72, '72'];
export const showProductDetailsToCustomerInProductionAnalysis = [63, '63'];
export const notShowmultipleOrders = [52, '52'];